import { API_BASE_URL } from "@kupikupi/brand";
import { useMutation } from "@tanstack/react-query";
import { type TelegramInitDataLoginInput, telegramMiniAppLogin } from "../endpoints/third-login";
import type { LoginVo } from "../types/user";

/**
 * `POST /sys/thirdLogin/telegram/initData` — Telegram Mini App silent login.
 *
 * Exchanges a raw `initData` string for a `LoginVo` (JWT + user). The Mini App
 * shell calls `mutateAsync({ initData })` once on boot; the caller persists
 * `result.xaccessToken` and feeds it into every auth-gated hook. Stateless on
 * the backend (bot-token HMAC), so there is no captcha/redirect dance.
 */
export function useTelegramLogin() {
  return useMutation<LoginVo, Error, TelegramInitDataLoginInput>({
    mutationFn: (input) => telegramMiniAppLogin({ baseUrl: API_BASE_URL }, input),
  });
}
